import React from 'react';
import { ButtonContainer } from '../jsxElements/Button';

import { AmpFlagSet } from '../amplitude';

export type MSHeroAttachmentData = {
    buttons: {
        type: string;
        title: string;
        value: string;
    }[];
};

export type MSHeroAttachmentArgs = {
    data: MSHeroAttachmentData;
    disableButtons: boolean;
    featureFlags: AmpFlagSet;
    sendMessage: (message: string) => void;
};

export const MSHeroAttachment: React.FC<MSHeroAttachmentArgs> = ({
    data,
    disableButtons,
    featureFlags,
    sendMessage,
}: MSHeroAttachmentArgs) => (
    <ButtonContainer
        buttons={data.buttons.map((button, index) => ({
            button,
            disableButtons,
            featureFlags,
            index,
            sendMessage,
        }))}
        featureFlags={featureFlags}
    />
);
